module.exports = __webpack_public_path__ + "static/media/banner_01.950e216f.png";